import React from "react";
import TokenListItem from "./TokenListItem";

const TokensList = ({ tokens }) => {
  return (
    <ul className="grid grid-cols-2 gap-y-3 gap-x-6 lg:grid-cols-4 items-center lg:gap-3">
      {tokens.map(({ id, tokenName, tokenValue }) => (
        <TokenListItem key={id} tokenName={tokenName} tokenValue={tokenValue} />
      ))}
    </ul>
  );
};

export default TokensList;
